import { render, staticRenderFns } from "./HelpExameKlis.vue?vue&type=template&id=74e33a6f&"
import script from "./HelpExameKlis.vue?vue&type=script&lang=js&"
export * from "./HelpExameKlis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports